//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const NewMessages = createAsyncThunk(
  "NewMessages",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingNewMessages(""));
      const response = await UsePortalApi(
        `Patient/Message`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response, "response");
        dispatch(gettingNewMessagesSuccess(response));
      } else {
        dispatch(gettingNewMessagesFailed(response?.errorMessage));
      }
    } catch (error) {
      dispatch(gettingNewMessagesFailed(error));
    }
  }
);
const NewMessagesSlice = createSlice({
  name: "NewMessages",
  initialState: {
    isSending: false,
    SendMessage: "",
    error: false,
    isSendMessageSuccess: false, // use for to handle the condition in ComposeMessageWebHandler
    isReplyMessageSuccess: false,
  },
  reducers: {
    gettingNewMessages: (state, action) => {
      state.SendMessage = "";
      state.isSending = true;
      state.isSendMessageSuccess = false;
    },
    gettingNewMessagesSuccess: (state, action) => {
      state.isSending = false;
      state.SendMessage = action.payload;
      state.isSendMessageSuccess = true;
      state.isReplyMessageSuccess= true
    },
    // gettingReplyMessagesSuccess: (state, action) => {
    //   state.isSending= false;
    //   state.SendMessage= action.payload;
    //   state.isReplyMessageSuccess= true
    // },
    
    gettingNewMessagesFailed: (state, action) => {
      state.isSending = false;
      state.SendMessage = action.payload;
      state.error = true;
      state.isSendMessageSuccess = false;
    },
    gettingNewMessagesClear: (state, action) => {
      state.isSending = false;
      state.SendMessage = "";
      state.error = false;
      state.isSendMessageSuccess = false;
      state.isReplyMessageSuccess= false
    },
  },
});
export const {
  gettingNewMessages,
  gettingNewMessagesSuccess,
  gettingNewMessagesFailed,
  gettingNewMessagesClear,
} = NewMessagesSlice.actions;
export default NewMessagesSlice.reducer;
